/**
 * Emergent-managed Google sign-in entry point.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { LogIn } from "lucide-react";

const AUTH_BASE = "https://auth.emergentagent.com/";

export const GoogleSignInButton = ({ returnPath, label = "Continue with Google", testid = "google-signin-button" }) => {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + returnPath;
    window.location.href = `${AUTH_BASE}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={start}
      data-testid={testid}
      className="w-full inline-flex justify-center items-center gap-2.5 bg-white border border-linen-border hover:border-navy/40 text-navy font-semibold text-sm px-6 py-3 rounded-full transition-all hover:-translate-y-0.5 hover:shadow-soft"
    >
      <GoogleGlyph />
      {label}
      <LogIn size={14} className="opacity-0" aria-hidden />
    </button>
  );
};

const GoogleGlyph = () => (
  <svg width="17" height="17" viewBox="0 0 18 18" aria-hidden focusable="false">
    <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.91c1.7-1.57 2.69-3.88 2.69-6.62z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.91-2.26c-.81.54-1.84.86-3.05.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.34A9 9 0 0 0 9 18z" />
    <path fill="#FBBC05" d="M3.97 10.72a5.41 5.41 0 0 1 0-3.44V4.94H.96a9 9 0 0 0 0 8.12l3.01-2.34z" />
    <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59C13.46.89 11.43 0 9 0A9 9 0 0 0 .96 4.94l3.01 2.34C4.68 5.16 6.66 3.58 9 3.58z" />
  </svg>
);

export const AuthDivider = ({ label = "or" }) => (
  <div className="flex items-center gap-3 my-5" aria-hidden>
    <span className="h-px flex-1 bg-linen-border" />
    <span className="text-[11px] uppercase tracking-[0.18em] text-ink-500">{label}</span>
    <span className="h-px flex-1 bg-linen-border" />
  </div>
);
